import React, {Component} from 'react';
import {NavBar, ListView, Toast,Modal} from 'antd-mobile';
import {nationalActivity} from '../../service/addLines';
import {connect} from "react-redux"; import {weiChatAuthor} from "../../config/config";
import './style.less';
let pageIndex = 1;
const notActivity = require('../../common/image/notActivity.png');
@connect(
    state => ({userInfo: state.userInfo})
)
export default class Activity extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            modal:false,
            notDataLoading:0,

            lineId:'',
            timerId:'',
            isLoading:true,
            tagIndex: 0,
            selectedIndex:0,
            lineData: [], 
            total:0,
            dataSource
        };
    }
 
    componentDidMount() {
        this.lineListData();
    };
    
    lineListData(){
        let params={
            pageSize:10,
            pageNo:1,
        };
        nationalActivity(params)
            .then((res)=>{
                Toast.hide();
                if (res.data.code === '000000') {
                    pageIndex = 1;
                    this.setState({
                        lineData: res.data.data == '' ? [] : res.data.data.list,
                        total:res.data.data.pageCount
                    });
                    this._setDataSource(this.state.lineData)
                    if(pageIndex*10 >= this.state.total){
                        this.setState({
                            isLoading:false,
                        });
                    }
                }else if (res.data.code === '100003') {
                    Modal.alert('提示', '登录过期，是否要重新登录?', [
                        { text: '取消'},
                        { text: '确认', onPress: () =>  window.location.href  = weiChatAuthor(0) },
                    ]);
                }
            }).catch(function (error) {
                Toast.hide();
                console.log(error);
            });
    };
     
       //拼接数据
    _setDataSource(dataSource){
        if(!dataSource) return false;
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(dataSource),
        });
    };

    //上拉加载
    _onEndReached = () =>{
        if(pageIndex * 10 >= this.state.total){
            this.setState({
                isLoading:false,
            });
            return false;
        }
        let params={
            pageSize:10,
            pageNo:++pageIndex
        };
        nationalActivity(params)
            .then((res)=>{
                const allData = [...this.state.lineData, ...res.data.data.list];
                this._setDataSource(allData);
                this.setState({
                    lineData:allData,
                    total: res.data.data.pageCount
                });
            }).catch(function (error) {
            console.log(error);
        });
    };

  modal(id,timerId){
    this.setState({
        modal:!this.state.modal,
        lineId:id,
        timerId:timerId
    })
  };
   
    render() {
        const {lineData} = this.state;
        let index = '';
        if(lineData){
             index = lineData.length - 1;
        }
        const _renderRow = (rowData) => {
            if (index < 0) {
                index = lineData.length - 1;
            }
            return(
                <div className="lineItem" key={rowData.activityId} 
                    onClick={() => this.modal(rowData.lineId,rowData.timerId)}
                >
                    <div className="itemLeft">
                            <div className="line">{rowData.startName}——{rowData.endName}</div>
                            {  <div className="fontsize28">原价：<span className="price">￥{rowData.origPrice}起</span> &nbsp;<span className="colorRed">￥{rowData.currentPrice}</span></div> }
                            <div className="lineTips" style={{clear:"both"}}>{rowData.startTime}~{rowData.endTime}</div>
                            <div className="floatR"><span className="discount">积分折扣{rowData.point}元</span></div>                           
                    </div>
                </div>
            )
        };

        return (
            <div className="Activity">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >折扣活动</NavBar>
                <Modal
                    style={{background: 'white'}}
                    visible={this.state.modal}
                    transparent
                    maskClosable={false}
                    title="温馨提示"
                    footer={[{
                        text: '知道了', onPress: () => this.props.history.push('/addPassenger',{lineId:this.state.lineId,id:this.state.timerId})
                    }]}
                >
                    <div className="modal">此功能随时可能下架,请勿过渡依赖，折扣活动默认选择距离你当前时间一小时之后的最近排班。</div>
                </Modal>
                {
                    <div className="linesList">
                        {
                            this.state.lineData.length ? (
                                <ListView
                                    ref={el => this.lv = el}
                                    dataSource={this.state.dataSource}
                                    renderFooter={() => (<div style={{ padding:10, textAlign: 'center' }}>
                                        {this.state.isLoading ? '数据加载中' : '没有更多'}
                                    </div>)}
                                    renderRow={_renderRow}
                                    style={{
                                        height: '100%',
                                        overflow: 'auto',
                                    }}
                                    scrollRenderAheadDistance={300}
                                    onEndReached={this._onEndReached}
                                    onEndReachedThreshold={30}
                                />
                            ) :<div className="noMore">
                                <img src={notActivity} />
                                <p>暂无活动</p>
                            </div>
                        }
                    </div>
                }
            </div>
        )
        
    }
}



// WEBPACK FOOTER //
// ./src/container/Activity/index.js